import { render, staticRenderFns } from "./editQas.vue?vue&type=template&id=a4128cfa&scoped=true"
import script from "./editQas.vue?vue&type=script&lang=js"
export * from "./editQas.vue?vue&type=script&lang=js"
import style0 from "./editQas.vue?vue&type=style&index=0&id=a4128cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4128cfa",
  null
  
)

export default component.exports